import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import Search from "@/pages/Search";
import MovieDetail from "@/pages/MovieDetail";
import Watch from "@/pages/Watch";
import Creators from "@/pages/Creators";
import CreatorProfile from "@/pages/CreatorProfile";
import Dashboard from "@/pages/Dashboard";
import CreatorDashboard from "@/pages/CreatorDashboard";
import Subscriptions from "@/pages/Subscriptions";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Register from "@/pages/Register";

function Shell() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  const isWatch = location.pathname.startsWith("/watch/");
  return (
    <div className="min-h-screen bg-[#08070B] text-white flex flex-col">
      {!isWatch && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/search" element={<Search />} />
          <Route path="/movie/:id" element={<MovieDetail />} />
          <Route path="/watch/:id" element={<Watch />} />
          <Route path="/creators" element={<Creators />} />
          <Route path="/creator/:id" element={<CreatorProfile />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/creator/dashboard" element={
            <ProtectedRoute roles={["CREATOR", "ADMIN"]}><CreatorDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={
            <ProtectedRoute roles={["ADMIN"]}><Admin /></ProtectedRoute>} />
        </Routes>
      </main>
      {!isWatch && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
